var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownlaod3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2539 2.43262H14.3734C15.0329 2.43262 15.5676 2.96724 15.5676 3.62672V15.5678C15.5676 16.2273 15.0329 16.7619 14.3734 16.7619H3.62648C2.967 16.7619 2.43237 16.2273 2.43237 15.5678V3.62672C2.43237 2.96724 2.96699 2.43262 3.62648 2.43262H5.74602",
    stroke: "#453AD1",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.791 4.22355H7.2087C6.38433 4.22355 5.71606 3.55528 5.71606 2.73092C5.71606 1.90655 6.38433 1.23828 7.2087 1.23828H10.791C11.6154 1.23828 12.2837 1.90655 12.2837 2.73092C12.2837 3.55528 11.6154 4.22355 10.791 4.22355Z",
    stroke: "#453AD1",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.7766V7.20898",
    stroke: "#453AD1",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61182 11.3882L9.00003 13.7764L11.3882 11.3882",
    stroke: "#453AD1",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownlaod3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downlaod3.a616b0c1338bbae76407107a7f8f8660.svg";